import { ActionTypes, ReduxAction } from './types';
import { Benutzer, BenutzerService } from '../../api';
import { Dispatch } from 'redux';
import { setNotification } from '../../utils/notificationUtils';
import { INFO } from '../../layouts/notification/Notification';

export const saveBenutzer =
  (benutzer: Benutzer, closeFunction?: () => void) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new BenutzerService().createBenutzer(benutzer).then(response => {
      dispatch({
        type: ActionTypes.SAVE_BENUTZER,
        payload: response.data,
      });
      setNotification(
        'Der Benutzer ' +
          response.data.name +
          ' wurde erfolgreich gespeichert.',
        []
      );
      if (closeFunction !== undefined) closeFunction();
      dispatch({
        type: ActionTypes.RELOAD_USERMANAGEMENT,
      });
    });
  };

export const updateBenutzer =
  (benutzerId: number, benutzer: Benutzer, closeFunction?: () => void) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new BenutzerService()
      .updateBenutzer(benutzerId, benutzer)
      .then(response => {
        dispatch({
          type: ActionTypes.UPDATE_BENUTZER,
          payload: response.data,
        });
        if (closeFunction !== undefined) closeFunction();
        setNotification(
          'Der Benutzer ' +
            response.data.name +
            ' wurde erfolgreich aktualisiert.',
          [],
          INFO,
          10000
        );
        dispatch({
          type: ActionTypes.RELOAD_USERMANAGEMENT,
        });
      });
  };

export const setBenutzerValue =
  (value: string | number | undefined | boolean, fieldName: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_BENUTZER,
      payload: {
        value: value,
        fieldName: fieldName,
      },
    });
    if (fieldName === 'rowsInGrid') {
      dispatch({
        type: ActionTypes.SET_ROWSINGRID,
        payload: value,
      });
    }
  };

export const getBenutzerById =
  (id: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new BenutzerService().getBenutzerById(id).then(response => {
      dispatch({
        type: ActionTypes.GET_BENUTZER_BY_ID,
        payload: response.data,
      });
    });
  };

export const resetBenutzererfassung =
  () => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.RESET_BENUTZERERFASSUNG,
    });
  };
